export class PlateListDTO {
    labId!: string;
    type!: string;
    processFlowName!: string;
    status?: string;
    fromDate?: string;
    toDate?: string;  
    selectedProjects?: string;
    selectedProtocolWorkflows?: string;
}